/**
 * Dynamically loads a script into the document head.
 * - If no `src` is provided, the function resolves immediately without appending a script element.
 * - In a development environment (`NODE_ENV === 'development'`), the function resolves immediately without loading any script.
 *
 * @param {Object} params - The HTML Script element props to apply to the script.
 */
export const loadScript = ({ src, ...rest }: React.HTMLProps<HTMLScriptElement>): void => {
  if (process.env.NODE_ENV === 'development' || !src) {
    return;
  }

  const script = document.createElement('script');
  Object.assign(script, rest);
  script.src = src;

  document.head.appendChild(script);
};
